import * as yup from 'yup';
import { useTranslate } from '@tolgee/react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCallback } from 'react';
import SelectField from '@amf/shared/components/form/SelectField';

export enum StatsType {
  assists = 'assists',
  goals = 'goals',
  points = 'points',
}

const schema = yup.object({
  type: yup.string(),
});

type FormData = {
  type: string;
};

const defaultValues: FormData = {
  type: StatsType.points,
};

type Props = {
  onChange?: (type: StatsType) => void;
  disableAssists?: boolean;
  disablePoints?: boolean;
};

function SeasonPlayerStatsFilter({ onChange, disableAssists, disablePoints }: Props) {
  const { t } = useTranslate();
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const update = useCallback(
    (data: FormData) => {
      if (!onChange) return;
      onChange(data.type as StatsType);
    },
    [onChange],
  );

  watch(update);

  return (
    <div className='Filter'>
      <form onSubmit={handleSubmit(update)} className='Filter__form'>
        <Controller
          name='type'
          control={control}
          render={({ field }) => (
            <SelectField
              className='Filter__field'
              label={t('stats.menu.title')}
              error={errors.type?.message}
              {...field}
            >
              {!disablePoints && <option value={StatsType.points}>{t('stats.menu.points')}</option>}
              <option value={StatsType.goals}>{t('stats.menu.goals')}</option>
              {!disableAssists && (
                <option value={StatsType.assists}>{t('stats.menu.assists')}</option>
              )}
            </SelectField>
          )}
        />
      </form>
    </div>
  );
}

export default SeasonPlayerStatsFilter;
